import type { IconProps } from './IconProps';

export const FileIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M9.33268 1.5127V4.26639C9.33268 4.63976 9.33268 4.82644 9.40534 4.96905C9.46926 5.09449 9.57125 5.19648 9.69669 5.26039C9.8393 5.33305 10.026 5.33305 10.3993 5.33305H13.153M9.33268 11.333H5.33268M10.666 8.66634H5.33268M13.3327 6.65849V11.4663C13.3327 12.5864 13.3327 13.1465 13.1147 13.5743C12.9229 13.9506 12.617 14.2566 12.2407 14.4484C11.8128 14.6663 11.2528 14.6663 10.1327 14.6663H5.86602C4.74591 14.6663 4.18586 14.6663 3.75803 14.4484C3.38171 14.2566 3.07575 13.9506 2.884 13.5743C2.66602 13.1465 2.66602 12.5864 2.66602 11.4663V4.53301C2.66602 3.4129 2.66602 2.85285 2.884 2.42503C3.07575 2.0487 3.38171 1.74274 3.75803 1.55099C4.18586 1.33301 4.74591 1.33301 5.86602 1.33301H8.0072C8.49638 1.33301 8.74097 1.33301 8.97115 1.38827C9.17522 1.43726 9.37031 1.51807 9.54925 1.62773C9.75108 1.75141 9.92404 1.92436 10.2699 2.27027L12.3954 4.39575C12.7413 4.74165 12.9143 4.9146 13.038 5.11644C13.1476 5.29538 13.2284 5.49047 13.2774 5.69454C13.3327 5.92472 13.3327 6.16931 13.3327 6.65849Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
